class LPFeatureProductCalloutAddToCart extends HTMLElement {
  // Constructor initializes default texts for button states
  constructor() {
    super();
    this.addedProductText = "ADDED TO THE BAG";
    this.addingProductText = "ADDING TO THE CART...";
  }

  // Callback when the element is added to the DOM
  connectedCallback() {
    this.section = this;
    this.section.addEventListener("click", this.sectionEventHandler.bind(this));
  }

  // Callback when the element is removed from the DOM
  disconnectedCallback() {
    this.section.removeEventListener(
      "click",
      this.sectionEventHandler.bind(this)
    );
  }

  /**
   * Event handler for click events on the element
   * @param {Event} event Event object
   */
  sectionEventHandler(event) {
    const bundleItemAddToCartBtn = event.target.closest(
      ".bundle-item-add-to-cart"
    );

    const singleItemAddToCartBtn = event.target.closest(
      ".single-item-add-to-cart"
    );

    const bundleItemBtn = event.target.closest(".bundle-item-btn");

    // If the click is on a bundle item's "Add to Cart" button
    if (bundleItemAddToCartBtn) {
      const selectedBundle = this.section.querySelector(
        `.bundle-item-btn[data-bundle-item-selected="true"]`
      );
      const { variantId } = selectedBundle.dataset;
      this.addToCart(variantId, bundleItemAddToCartBtn);
      return;
    }

    // If the click is on a single item's "Add to Cart" button
    if (singleItemAddToCartBtn) {
      const { variantId } = singleItemAddToCartBtn.dataset;
      this.addToCart(variantId, singleItemAddToCartBtn);
      return;
    }

    // If the click is on a single item's "Add to Cart" button
    if (bundleItemBtn) {
      const selectedItem = this.section.querySelector(
        `.bundle-item-btn[data-bundle-item-selected="true"]`
      );
      selectedItem.dataset.bundleItemSelected = false;
      bundleItemBtn.dataset.bundleItemSelected = true;
      return;
    }
  }

  /**
   * Async method to add a product variant to the cart
   * @param {String} variantId Variant id to add to cart
   * @param {HTMLElement} buttonClicked Clicked button
   */
  async addToCart(variantId, buttonClicked) {
    const formData = {
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
    };

    buttonClicked.innerHTML = this.addingProductText;

    try {
      await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
    } catch (error) {
      console.log(`❌ 👉🏻 LPFeatureProductCalloutAddToCart | ${error.message}`);
    } finally {
      buttonClicked.innerHTML = this.addedProductText;
      buttonClicked.disabled = true;
    }
  }
}

customElements.define(
  "landing-page-feature-product-callout-add-to-cart",
  LPFeatureProductCalloutAddToCart
);
